import { render } from "./order_details.vue?vue&type=template&id=fc044b6c&scoped=true"
import script from "./order_details.vue?vue&type=script&lang=js"
export * from "./order_details.vue?vue&type=script&lang=js"

import "./order_details.vue?vue&type=style&index=0&id=fc044b6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc044b6c"]])

export default __exports__